import { photoUrlBase } from 'constants/common';
import { OptionsButtonItem } from 'containers/tinting/options/components/buttons-list';
import { TintingOptionsType } from './types';

/* eslint-disable max-lines */
export const bannerSrc = `${photoUrlBase}/NjYHAtU-fUaHJnUBTvhp2g/services-platform-landing-kolerovka-main.png`;

export const orderStepsContent = [
	{
		header: 'Нажмите на кнопку «Колеровка онлайн» в каталоге',
		text:
			'Зайдите в каталог и выберите нужную категорию товаров. Нажмите на кнопку «Колеровка онлайн» в верхнем меню.',
		stepImg: `${photoUrlBase}/HOtXPB4QyEa-lhoOP4I3LA/services-platform-landing-kolerovka-order-step-1__n.webp`,
		stepImgMin: `${photoUrlBase}/t-7VK2189kC0oVxwqHF6cQ/services-platform-landing-kolerovka-order-step-1-min.png`,
		stepImgTab: `${photoUrlBase}/0aHnWIQHlUKn0IQXed51eA/services-platform-landing-kolerovka-order-step-1-tablet_n__1.webp`,
		stepImgTabMin: `${photoUrlBase}/_EQ3n7mrkkeb4868k1kouQ/services-platform-landing-kolerovka-order-step-1-tablet-min.png`,
		stepImgMob: `${photoUrlBase}/0PnxhukZekiNHItmTfq9-w/services-platform-landing-kolerovka-order-step-1-mob__n_1.webp`,
	},
	{
		header: 'Выберите товар в каталоге',
		text: 'Выберите товар в каталоге и откройте страницу с его описанием.',
		stepImg: `${photoUrlBase}/CNRNiM00iUOj0FuqNQ6sCQ/services-platform-landing-kolerovka-order-step-2__n.webp`,
		stepImgTab: `${photoUrlBase}/eNxbJT1dGUaDarW2QilzTg/services-platform-landing-kolerovka-order-step-2-tablet__n__1.webp`,
		stepImgMob: `${photoUrlBase}/vwROCB900E62Mz2ybHa9tg/services-platform-landing-kolerovka-order-step-2-mob__n_1.webp`,
	},
	{
		header: 'Откройте палитру в описании товара',
		text: 'Найдите в описании товара зелёную ссылку на палитру и откройте её.',
		stepImg: `${photoUrlBase}/orZY-Sb8DESL3FqjdMn1Rw/services-platform-landing-kolerovka-order-step-3__n.webp`,
		stepImgTab: `${photoUrlBase}/2sj9C6iCX0WL9twLBRwvBA/services-platform-landing-kolerovka-order-step-3-tablet__n__1.webp`,
		stepImgMob: `${photoUrlBase}/zlzRPm4tBEeueY_9ZoQGuQ/services-platform-landing-kolerovka-order-step-3-mob__n_1.webp`,
	},
	{
		header: 'Выберите цвет и запомните его код',
		text: 'В палитре выберите нужный цвет и запомните или запишите его код.',
		stepImg: `${photoUrlBase}/ufGZ9ns1nkK_OCPzsAJHcw/services-platform-landing-kolerovka-order-step-4__n.webp`,
		stepImgTab: `${photoUrlBase}/LHy1lLvGqUSFv921CJuauA/services-platform-landing-kolerovka-order-step-4-tablet__n__1.webp`,
		stepImgMob: `${photoUrlBase}/C6MsI27au0SgdG5HLJcxrQ/services-platform-landing-kolerovka-order-step-4-mob__n_1.webp`,
	},
	{
		header: 'Добавьте товар в корзину и укажите код цвета в комментарии к доставке',
		text:
			'Вернитесь на страницу товара, добавьте его в корзину и укажите код цвета в комментарии к доставке при оформлении заказа.',
		stepImg: `${photoUrlBase}/P--9pMroEUuqo0P4Tw3L2A/services-platform-landing-kolerovka-order-step-5__n2.png`,
		stepImgTab: `${photoUrlBase}/Ef05VXQsi0aAq31ufsEzYg/services-platform-landing-kolerovka-order-step-5-tablet_n__1.png`,
		stepImgMob: `${photoUrlBase}/dA6OhwGKJUKTWUUhHYCS0w/services-platform-landing-kolerovka-order-step-5-mob__n_1.webp`,
	},
];

export const tintingOptions: TintingOptionsType = {
	paint: [
		{
			img: `${photoUrlBase}/wvl_HydBxEWfyt8hJMp2aA/services-platform-landing-kolerovka-paint-1.png`,
			text: 'Краски для стен и потолков',
			src: '/catalogue/kraski-dlya-sten-i-potolkov/kolerovka/',
		},
		{
			img: `${photoUrlBase}/U86Yxyg-MEu_-rGTwcoEtA/services-platform-landing-kolerovka-paint-2.png`,
			text: 'Декоративные краски',
			src: '/catalogue/dekorativnye-kraski/kolerovka/',
		},
		{
			img: `${photoUrlBase}/deN67Xwem06xZUN8wAaYmw/services-platform-landing-kolerovka-paint-3.png`,
			text: 'Краски для пола',
			src: '/catalogue/kraski-dlya-pola/kolerovka/',
		},
		{
			img: `${photoUrlBase}/8Q3NTI64gE-uROSYez75Qg/services-platform-landing-kolerovka-paint-4.png`,
			text: 'Фасадные краски',
			src: '/catalogue/fasadnye-kraski/kolerovka/',
		},
	],
	plaster: [
		{
			img: `${photoUrlBase}/Fj704gir6ky7iV-fjHB_Dw/services-platform-landing-kolerovka-plaster-1.png`,
			text: 'Декоративные штукатурки',
			src: '/catalogue/dekorativnye-shtukaturki/kolerovka/',
		},
		{
			img: `${photoUrlBase}/R_98hpyQWEeTyA_-ycsFLw/services-platform-landing-kolerovka-plaster-2.png`,
			text: 'Фасадные штукатурки',
			src: '/catalogue/fasadnye-shtukaturki/kolerovka/',
		},
	],
	enamel: [
		{
			img: `${photoUrlBase}/OCJLgzf2nUGZK1qgZs1Lpw/services-platform-landing-kolerovka-emal-1.jpg`,
			text: 'Эмали для наружных и внутренних работ',
			src: '/catalogue/emali-dlya-naruzhnyh-i-vnutrennih-rabot/kolerovka/',
		},
		{
			img: `${photoUrlBase}/JLH3UjvAfkK2zeg845g9UA/services-platform-landing-kolerovka-emal-2.jpg`,
			text: 'Эмали по ржавчине',
			src: '/catalogue/emali-po-rzhavchine/kolerovka/',
		},
		{
			img: `${photoUrlBase}/MgT4SjfBnEid4e7WnYvnbA/services-platform-landing-kolerovka-emal-3.jpg`,
			text: 'Эмали для мебели',
			src: '/catalogue/emali-dlya-mebeli/kolerovka/',
		},
		{
			img: `${photoUrlBase}/Jju4hvDDnEWp_-M33AuDFw/services-platform-landing-kolerovka-emal-4.jpg`,
			text: 'Эмали для окон и дверей',
			src: '/catalogue/emali-dlya-okon-i-dverey/kolerovka/',
		},
		{
			img: `${photoUrlBase}/PajiwIrzY06bV4IT7UAcNQ/services-platform-landing-kolerovka-emal-5.jpg`,
			text: 'Эмали для радиаторов',
			src: '/catalogue/emali-dlya-radiatorov/kolerovka/',
		},
		{
			img: `${photoUrlBase}/DMf8UF-d1U6JyWJ6vkUbnQ/services-platform-landing-kolerovka-emal-6.jpg`,
			text: 'Эмали для пола и лестниц',
			src: '/catalogue/specialnye-emali/kolerovka/',
		},
		{
			img: `${photoUrlBase}/yaXrXYVVTkWBHkW5LdN2Ow/services-platform-landing-kolerovka-emal-7.jpg`,
			text: 'Специальные эмали',
			src: '/catalogue/specialnye-emali/kolerovka/',
		},
	],
	wood: [
		{
			img: `${photoUrlBase}/yiRHJfVHeEWibIN_o2yiYA/services-platform-landing-kolerovka-wood-1.png`,
			text: 'Антисептики для дерева',
			src: '/catalogue/antiseptiki-dlya-dereva/kolerovka/',
		},
		{
			img: `${photoUrlBase}/RQmb2aPR_kCMmHWiRiz3FA/services-platform-landing-kolerovka-wood-2.jpg`,
			text: 'Пропитки для дерева',
			src: '/catalogue/laki-dlya-dereva/kolerovka/',
		},
		{
			img: `${photoUrlBase}/95e3AOu9GEGjJdTHTU5neQ/services-platform-landing-kolerovka-wood-3.jpg`,
			text: 'Лаки для дерева',
			src: '/catalogue/laki-dlya-dereva/kolerovka/',
		},
		{
			img: `${photoUrlBase}/h8i-CuoQLk69SfnRj3vZWA/services-platform-landing-kolerovka-wood-4.jpg`,
			text: 'Масла и воски для дерева',
			src: '/catalogue/masla-i-voski-dlya-dereva/kolerovka/',
		},
		{
			img: `${photoUrlBase}/5TtzjgKYqUGAyAmxnpTkzw/services-platform-landing-kolerovka-wood-5.jpg`,
			text: 'Паркетные лаки',
			src: '/catalogue/parketnye-laki/kolerovka/',
		},
	],
};

export const optionButtons: OptionsButtonItem[] = [
	{ text: 'Краски', optionName: 'paint' },
	{ text: 'Штукатурки', optionName: 'plaster' },
	{ text: 'Эмали', optionName: 'enamel' },
	{ text: 'Покрытия для дерева', optionName: 'wood' },
];

export const questionsArr = [
	{
		question: 'Что такое компьютерная колеровка краски?',
		answer:
			'Компьютерная колеровка — это смешивание на специальном оборудовании белой или прозрачной базы с цветными колерами для придания краске уникального оттенка, который вы выберете из огромной цветовой палитры.',
	},
	{
		question: 'Что обозначает база краски?',
		answer:
			'Белая база А — это краска, которую можно использовать как белую или колеровать в пастельные тона. Базы C, BC и другие — это прозрачные базы, которые используются только для колеровки в насыщенные тона.',
	},
	{
		question: 'В чем разница между пастельными и насыщенными оттенками?',
		answer: 'Пастельные — это светлые и мягкие оттенки. Насыщенные — это яркие и тёмные цвета.',
	},
	{
		question: 'Отличаются ли цвета на экране и в реальности?',
		answer:
			'Цвет, который вы видите на экранах разных устройств, может отличаться от реального цвета при покраске. Это связано с индивидуальной цветопередачей вашего устройства. Если вы не уверены в выборе цвета, вы можете заказать несколько маленьких банок краски, заколерованной в разные цвета, и сделать тестовые выкрасы. А после уже приобретать весь необходимый для покраски объём.',
	},
	{
		question: 'Сколько стоит услуга колеровки онлайн?',
		answer:
			'При заказе на сайте услуга колеровки входит в стоимость краски, лака или штукатурки.',
	},
	{
		question: 'Я знаю код краски, но в палитре этого цвета нет. Могу ли я заказать этот цвет?',
		answer:
			'Да, это возможно. Укажите код цвета в комментарии и, если выбранную краску можно заколеровать в этот цвет, мы заколеруем. Если нет, мы перезвоним и предложим похожие варианты.',
	},
	{
		question: 'Что делать, если в комментарии я неверно укажу код цвета?',
		answer:
			'Если вы ошиблись с кодом, мы не сможем заколеровать краску и перезвоним вам, чтобы заново оформить заказ.',
	},
	{
		question: 'Какой минимальный объём для колеровки?',
		answer: 'Минимальный объём краски для колерования — 250мл.',
	},
];
